import { render, staticRenderFns } from "./WineProductReviews.vue?vue&type=template&id=194a9c3c&scoped=true"
import script from "./WineProductReviews.vue?vue&type=script&lang=js"
export * from "./WineProductReviews.vue?vue&type=script&lang=js"
import style0 from "./WineProductReviews.vue?vue&type=style&index=0&id=194a9c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194a9c3c",
  null
  
)

export default component.exports